// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Pg0","largestCol":"styles_largestCol__3ohJ8","smallestCol":"styles_smallestCol__1ZpHB"};